// extracted by mini-css-extract-plugin
module.exports = {"base":"LinkageHistory_base__1l5at","cell":"LinkageHistory_cell__1Wl24","dropDownSelection":"LinkageHistory_dropDownSelection__-39Eh"};